import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PreferenzaAmministratore } from '../models/preferenza-amministratore';
import { ResourcefulService } from './resourcefulService';

@Injectable({
  providedIn: 'root'
})
export class PreferenzaAmministratoreService extends ResourcefulService<PreferenzaAmministratore>{

  constructor(httpClient: HttpClient) {
    super(httpClient, PreferenzaAmministratore);
  }
}
